import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { logger } from '@/utils/logger';

export const useUserPoints = (userId?: string) => {
  const [points, setPoints] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUserPoints = async () => {
      if (!userId) {
        setIsLoading(false);
        return;
      }
      try {
        const { data, error } = await supabase
          .from('referrals')
          .select('reward_amount, reward_status')
          .eq('referrer_user_id', userId);
        if (error) throw error;
        const total = (data ?? []).reduce(
          (sum: number, r: any) => sum + Number(r.reward_amount ?? 0),
          0,
        );
        setPoints(total);
      } catch (error) {
        logger.error('Error fetching user points:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserPoints();
  }, [userId]);

  return { points, isLoading };
};
